<template>
  <yn-topic></yn-topic>
</template>

<script>
import Topic from '@/components/management/Topic';

export default {
  components: {
    'yn-topic': Topic
  }
};
</script>

<style scoped></style>
p
